import React from "react";
import { MapIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { CountdownTimer } from "../CountdownTimer";
import { images } from "../../data/landingContent";
export function HeroSection() {
  return <header className="bg-cream px-4 pb-14 pt-8 sm:pt-12" data-id="element-189" data-mp="218rqrus6eusm">
      <div className="mx-auto max-w-5xl text-center" data-id="element-190" data-mp="1x9ajqwx3pplc">
        <div className="inline-flex items-center gap-2 rounded-full border border-plum/15 bg-white px-3 py-1.5" data-id="element-191" data-mp="1x8hj8doqjwbn">
          <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-plum" data-id="element-192" data-mp="1sbhh2dv0bdpt">
            <MapIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-193" data-mp="1ngv4469a1d3m" />
          </span>
          <span className="font-serif text-base font-bold text-plum" data-id="element-194" data-mp="1ik4m3ddww7fk">Menopause Decision Map™</span>
          <span className="hidden text-sm text-muted sm:inline" data-id="element-195" data-mp="1dml90gsya0p7">· Built by Dr. Karito</span>
        </div>

        <h1 className="mx-auto mt-6 max-w-4xl text-balance font-serif text-[34px] font-extrabold leading-[1.1] text-ink sm:text-5xl lg:text-6xl" data-id="element-196" data-mp="19l9h24mlt3du">
          Stop searching through multiple medical guidelines. Organize your menopause assessment in{" "}
          <em className="text-rose" data-id="element-197" data-mp="36f48wd1oktza">under 5 minutes.</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-198" data-mp="2sng1gn2dmton">
          A practical, visual decision-making system designed to help physicians organize menopause assessments,
          identify relevant clinical considerations, and navigate the next steps with greater clarity. Includes{" "}
          <strong className="text-ink" data-id="element-199" data-mp="3pdyrjx49mekq">6 premium volumes</strong>, <strong className="text-ink" data-id="element-200" data-mp="3pbcjlwdgpx1z">5 exclusive bonuses</strong>,
          visual decision maps, clinical checklists, and practical consultation tools.
        </p>

        <img src={images.hero} alt="Menopause Decision Map™ collection: six volumes, decision maps and clinical checklists on tablet and laptop" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-201" data-mp="3gbpjrf0dszb1" />

        <CtaButton id="hero-cta" className="mt-4" label="Yes! I want Menopause Decision Map™" subtext="Instant Digital Access · One-Time Payment of $27 · Lifetime Access · 7-Day Money-Back Guarantee" data-id="element-202" data-mp="24vsicrbcwmwx" />

        <CountdownTimer data-id="element-203" data-mp="qsafeovl7g3" />
      </div>
    </header>;
}